import { CurrentUserFetcher } from "@indietabletop/appkit";
import { Redirect, Route, Switch } from "wouter";
import { hrefs } from "../hrefs.ts";
import { JoinPage, LoginPage, PasswordResetPage } from "./account.tsx";
import { CheckAccessProvider } from "./CheckAccess/CheckAccess.tsx";
import { CheckoutSuccessPage } from "./CheckoutSuccessPage/CheckoutSuccessPage.tsx";
import { DashboardPage } from "./DashboardPage/DashboardPage.tsx";
import { NotFoundPage } from "./failures/NotFoundPage.tsx";
import { GangPage, SharedGangPage } from "./GangPage/GangPage.tsx";
import { GangPrintPage } from "./GangPrintPage/GangPrintPage.tsx";
import { GangsPage } from "./GangsPage/GangsPage.tsx";
import { DocPages } from "./HelpPages/DocsPages.tsx";
import { Layout } from "./Layout/Layout.tsx";
import { NameGeneratorPage } from "./NameGeneratorPage/NameGeneratorPage.tsx";
import { OnboardingProvider } from "./Onboarding/OnboardingCard.tsx";
import { QuickStartPage } from "./QuickStartPage/QuickStartPage.tsx";
import { RedeemPage } from "./RedeemPage/RedeemPage.tsx";
import { RulesPage } from "./RulesPage/RulesPage.tsx";
import { SettingsPage } from "./SettingsPage/SettingsPage.tsx";

export function Routes() {
  return (
    <Switch>
      <Route path="/buy">
        <Redirect to={hrefs.rules()} />
      </Route>

      <Route path="/downloads">
        <Redirect to={hrefs.rules({ note: "loginNeeded" })} />
      </Route>

      <Route path="/print/g/:gangId">
        <GangPrintPage />
      </Route>

      <Route>
        <Layout>
          <Switch>
            {/* Public routes */}

            <Route path="/join">
              <JoinPage />
            </Route>

            <Route path="/login">
              <LoginPage />
            </Route>

            <Route path="/password">
              <PasswordResetPage />
            </Route>

            <Route path="/redeem/:id">
              <RedeemPage />
            </Route>

            <Route>
              {/* Routes where current user is checked */}
              <OnboardingProvider>
                <CheckAccessProvider>
                  <CurrentUserFetcher>
                    <Switch>
                      <Route path="/">
                        <DashboardPage />
                      </Route>

                      <Route path="/gangs">
                        <GangsPage />
                      </Route>

                      <Route path="/gangs/s/:gangId" nest>
                        <SharedGangPage />
                      </Route>

                      <Route path="/gangs/g/:gangId" nest>
                        <GangPage />
                      </Route>

                      <Route path="/rules">
                        <RulesPage />
                      </Route>

                      <Route path="/rules/quick-start">
                        <QuickStartPage />
                      </Route>

                      <Route path="/docs" nest>
                        <DocPages />
                      </Route>

                      <Route path="/settings">
                        <SettingsPage />
                      </Route>

                      <Route path="/names">
                        <NameGeneratorPage />
                      </Route>

                      <Route path="/checkout/sessions/:sessionId">
                        <CheckoutSuccessPage />
                      </Route>

                      <Route>
                        <NotFoundPage />
                      </Route>
                    </Switch>
                  </CurrentUserFetcher>
                </CheckAccessProvider>
              </OnboardingProvider>
            </Route>
          </Switch>
        </Layout>
      </Route>
    </Switch>
  );
}
